<app-spinner [loading]="false">
  <div class="creation-lead">
    <form
      [formGroup]="createLeadForm"
      class="flex flex--column flex--box"
      (ngSubmit)="onSubmit()"
    >
      <h3 class="text--upper_case text--center">Create lead</h3>

      <!-- <span class="error-message" *ngIf="errorMessage && errorMessage.length">{{errorMessage}}</span> -->
      <mat-form-field>
        <input
          type="text"
          placeholder="Pick up Location"
          aria-label="Pick up location text"
          matInput
          [formControlName]="fields.pickupLocation.name"
          [matAutocomplete]="pickupLocationAuto"
        />
        <mat-autocomplete #pickupLocationAuto="matAutocomplete" [displayWith]="displayLocation.bind(this)">
          <mat-option
            *ngFor="let option of pickupLocationOptions$ | async"
            [value]="option"
          >
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="createLeadForm.get(fields.pickupLocation.name)?.hasError('invalidLocation')">
          Select a valid address from the dropdown
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input
          type="text"
          placeholder="Delivery Location"
          aria-label="Delivery Location text"
          matInput
          [formControlName]="fields.deliveryLocation.name"
          [matAutocomplete]="deliveryLocationAuto"
        />
        <mat-autocomplete #deliveryLocationAuto="matAutocomplete" [displayWith]="displayLocation.bind(this)">
          <mat-option
            *ngFor="let option of deliveryLocationOptions$ | async"
            [value]="option"
          >
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="createLeadForm.get(fields.deliveryLocation.name)?.hasError('invalidLocation')">
          Select a valid address from the dropdown
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Trailer Type</mat-label>
        <mat-select formControlName="trailerType">
          <mat-option
            *ngFor="let type of trailerTypes"
            [value]="type.value"
          >
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div>
        <div class="add-car">
          <button type="button" mat-icon-button (click)="addCar()">
            <mat-icon>add</mat-icon>
          </button>
          <label>Add Car</label>
        </div>
        <div
          *ngIf="carFormGroups && carFormGroups.length > 0"
          class="cars-container"
        >
          <div *ngFor="let carFormGroup of carFormGroups; index as i">
            <app-create-lead-car
              [form]="carFormGroup"
              [index]="i"
              (OnRemove)="removeCar($event)"
            >
            </app-create-lead-car>
          </div>
        </div>
        <div
          *ngIf="carFormGroups && carFormGroups.length > 0"
          class="total-cars"
        >
          Cars Count: {{ carFormGroups.length }}
        </div>
      </div>

      <mat-form-field>
        <input
          type="text"
          placeholder="Email"
          aria-label="Email text"
          matInput
          [formControlName]="fields.email.name"
        />
      </mat-form-field>

      <div class="flex flex__justify-content--center">
        <button
          type="submit"
          [disabled]="createLeadForm.invalid"
          class="text--upper_case"
          mat-raised-button
          color="primary"
        >
          Create
        </button>
      </div>
    </form>
  </div>
</app-spinner>
